import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import ApiService from '@web-client/services/ApiService';
import { SubscriptionInfoForCreator, SubscriptionWithCreator } from '@server/other/classes';

interface SubInfoCollection{
  [key: string]: SubscriptionInfoForCreator;
}


export const getCreatorSubscription = createAsyncThunk(
  'subscriptions/getCreatorSubscription',
  async (userId: string) => {
    const subInfo = await ApiService.getInstance().getUserSubscription(userId);
    console.log('Subscription info:', subInfo);
    return subInfo;
  }
);

export const subscribeToCreator = createAsyncThunk(
  'subscriptions/subscribeToCreator',
  async (userId: string) => {
    const subInfo = await ApiService.getInstance().subscribeToCreator(userId);
    console.log('Subscription info:', subInfo);
    return subInfo;
  }
);

export const unsubscribeFromCreator = createAsyncThunk(
  'subscriptions/unsubscribeFromCreator',
  async (userId: string) => {
    const subInfo = await ApiService.getInstance().unsubscribeFromCreator(userId);
    console.log('Subscription info:', subInfo);
    return subInfo;
  }
);

export const getAllSubscriptions = createAsyncThunk(
  'subscriptions/getAllSubscriptions',
  async () => {
    const subs = await ApiService.getInstance().getAllSubscriptions();
    return subs;
  }
);

interface SubscriptionsState {
  subscriptionInfo: SubInfoCollection;
  isGettingSubscriptionInfo: boolean;
  isSubscribing: boolean;
  isUnsubscribing: boolean;
  subscriptionsList: SubscriptionWithCreator[];
  isGettingSubscriptionsList: boolean;
  subscriptionsListError: string | null;
}

const initialState: SubscriptionsState = {
  subscriptionInfo: {} as SubInfoCollection,
  isGettingSubscriptionInfo: false,
  isSubscribing: false,
  isUnsubscribing: false,
  subscriptionsList: [],
  isGettingSubscriptionsList: false,
  subscriptionsListError: null,
};

export const subscriptionsSlice = createSlice({
  name: 'subscriptions',
  initialState,
  reducers: {
    // addSubscription(state, action: PayloadAction<Subscription>) {
    //   state.subscriptions.push(action.payload);
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCreatorSubscription.pending, (state) => {
        console.log('Fetching subscription info...');
        state.isGettingSubscriptionInfo = true;
      })
      .addCase(getCreatorSubscription.fulfilled, (state, action) => {
        const subscriptionInfo = action.payload as SubscriptionInfoForCreator;
        console.log('Fetched subscription info:', subscriptionInfo);
        const targetCreatorId = subscriptionInfo.targetCreatorId;
        state.subscriptionInfo[targetCreatorId] = subscriptionInfo;
        state.isGettingSubscriptionInfo = false;
      })
      .addCase(getCreatorSubscription.rejected, (state, action) => {
        console.error('Failed to fetch subscription info:', action.error);
        state.isGettingSubscriptionInfo = false;
        state.subscriptionInfo = {};
      })
      .addCase(subscribeToCreator.pending, (state) => {
        console.log('Subscribing to creator...');
        state.isSubscribing = true;
      })
      .addCase(subscribeToCreator.fulfilled, (state, action) => {
        const subscriptionInfo = action.payload as SubscriptionInfoForCreator;
        console.log('Subscribed to creator:', subscriptionInfo);
        state.isSubscribing = false;
      })
      .addCase(subscribeToCreator.rejected, (state, action) => {
        console.error('Failed to subscribe to creator:', action.error);
        state.isSubscribing = false;
      })
      .addCase(unsubscribeFromCreator.pending, (state) => {
        console.log('Unsubscribing from creator...');
        state.isUnsubscribing = true;
      })
      .addCase(unsubscribeFromCreator.fulfilled, (state, action) => {
        const subscriptionInfo = action.payload as SubscriptionInfoForCreator;
        console.log('Unsubscribed from creator:', subscriptionInfo);
        state.isUnsubscribing = false;
      })
      .addCase(unsubscribeFromCreator.rejected, (state, action) => {
        console.error('Failed to unsubscribe from creator:', action.error);
        state.isUnsubscribing = false;
      })
      .addCase(getAllSubscriptions.pending, (state) => {
        state.isGettingSubscriptionsList = true;
        state.subscriptionsListError = null;
      })
      .addCase(getAllSubscriptions.fulfilled, (state, action) => {
        state.isGettingSubscriptionsList = false;
        state.subscriptionsList = action.payload;
      })
      .addCase(getAllSubscriptions.rejected, (state, action) => {
        state.isGettingSubscriptionsList = false;
        state.subscriptionsListError = action.error.message || 'Failed to fetch subscriptions';
      });
  },
  selectors: {
    subscriptionInfo: (state: SubscriptionsState) => state.subscriptionInfo,
    isGettingSubscriptionInfo: (state: SubscriptionsState) => state.isGettingSubscriptionInfo,
    isSubscribing: (state: SubscriptionsState) => state.isSubscribing,
    isUnsubscribing: (state: SubscriptionsState) => state.isUnsubscribing,
    subscriptionsList: (state: SubscriptionsState) => state.subscriptionsList,
    isGettingSubscriptionsList: (state: SubscriptionsState) => state.isGettingSubscriptionsList,
    subscriptionsListError: (state: SubscriptionsState) => state.subscriptionsListError,
  },

});

export const {

} = subscriptionsSlice.actions;

export const selectors = subscriptionsSlice.selectors;

export default subscriptionsSlice.reducer;